import { chapters, timelineSegments } from "@/data/chapters";
import SectionHeading from "@/components/base/SectionHeading";
import ChapterCard from "@/components/feature/ChapterCard";
import { Link } from "react-router-dom";

export default function ChapterPreview() {
  return (
    <section className="bg-background-100/40 py-14 md:py-20">
      <div className="container-page">
        <SectionHeading
          eyebrow="剧情分章节"
          title="按时间线，重新走一遍这个故事"
          description="从牌桌上的第一句客套话，到街角那把没人收走的椅子。每一章都可以单独进入，也可以顺着读下去。"
          actionLabel="查看全部章节"
          actionTo="/category"
        />

        <div className="mt-6 flex flex-wrap items-center gap-2">
          {timelineSegments.map((segment, index) => (
            <span
              key={segment}
              className="inline-flex items-center gap-1.5 rounded-full border border-background-300 px-3 py-1 font-label text-[11px] text-foreground-600"
            >
              <span className={`h-1.5 w-1.5 rounded-full ${index === 3 ? "bg-accent-500" : "bg-primary-600"}`} />
              {segment}
            </span>
          ))}
          <Link
            to="/category"
            className="ml-auto hidden items-center gap-1 font-label text-xs text-accent-500 hover:text-accent-400 sm:flex"
          >
            按时长排序
            <i className="ri-sort-desc text-sm leading-none" />
          </Link>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {chapters.slice(0, 6).map((chapter) => (
            <ChapterCard key={chapter.id} chapter={chapter} />
          ))}
        </div>
      </div>
    </section>
  );
}